export interface ReviewsBulkResponse {
    type: 'reviews-bulk';
    attributes: ReviewsBulk;
}

/***********************************/

export type PalBulkUnitIdentifier = 'unit_id' | 'pms_id';

export interface ReviewsBulk {
    email: string;
    file: string;
    note: string;
    is_pal_bulk_import?: boolean;
    pal_unit_identifier?: PalBulkUnitIdentifier;
}

export interface ReviewBulk {
    admin_unit_id: number;
    review_date: Date;
    guest_email: string;
    first_name: string;
    last_name: string;
    overall_rating: number;
    display_review: boolean;
    public_review_title: string;
    public_review: string;
    /** Host/management response; maps to reviews.response when set. */
    response?: string;
    /** PAL bulk PmsID mode: external PMS identifier from CSV. */
    pms_id?: string;
    /** Original CSV row fields for pending retry persistence. */
    row_data?: Record<string, string>;
}

export interface ReviewBulkWithUnit extends ReviewBulk {
    unit_id: number;
}

export interface ReviewsFileS3 {
    bulk_import_id: number;
    user_email: string;
    file_csv: string;
    is_pal_bulk_import?: boolean;
    pal_unit_identifier?: PalBulkUnitIdentifier;
}

export enum HeaderBulkTypes {
    UNIT_ID = 'UnitID',
    PMS_ID = 'PmsID',
    REVIEW_DATE = 'ReviewDate',
    GUEST_EMAIL = 'GuestEmail',
    GUEST_FIRST_NAME = 'GuestFirstName',
    GUEST_LAST_NAME = 'GuestLastName',
    OVERALL_RATING = 'OverallRating',
    DISPLAY_REVIEW = 'DisplayReview',
    PUBLIC_REVIEW_TITLE = 'PublicReviewTitle',
    PUBLIC_REVIEW = 'PublicReview',
    REVIEW_RESPONSE = 'ReviewResponse',
}

export type DataBulkTable = { [type in HeaderBulkTypes]: string | number | boolean | Date };
export type DataErrorBulk = { [key: string]: string | number | boolean | Date };
